export const init = () => {
  CUBE.Analytics.enhanced.plv2.es6.initImpression('#similar-product','similar-products');
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-impression-similar.js